import PackOpenAnimatorContainer from '../../shop/containers/packOpenAnimatorContainer';
import { definePrefab, preloadPrefabClips, stubClip } from '../prefab';
import { PLACEHOLDER_CARD_FILE, placeholderCardTexture } from '../placeholderCard';

const CARD_PERSPECTIVE = 900;

const previewCard = (id) => ({
    id,
    type: 'Character',
    imgUrl: PLACEHOLDER_CARD_FILE,
});

export const packOpenPrefab = definePrefab({
    id: 'packOpen',
    name: 'Pack opener',
    load: async () => {
        await Promise.all([
            PackOpenAnimatorContainer.loadStaticAssets(),
            preloadPrefabClips(packOpenPrefab),
        ]);
        placeholderCardTexture();
    },
    create: () => PackOpenAnimatorContainer.createPreview([
        previewCard('preview-hero'),
        previewCard('preview-next'),
    ]),
    parts: {
        background: { name: 'Background', pick: (root) => root.backdrop },
        pack: { name: 'Booster pack Container', pick: (root) => root.pack },
        wholePack: { name: 'Whole pack', pick: (root) => root.pack?.packWhole },
        tearTop: { name: 'Tear strip', pick: (root) => root.pack?.tearTop },
        tearBottom: { name: 'Teared Pack body', pick: (root) => root.pack?.tearBottom },
        hero: { name: 'Hero card', perspective: CARD_PERSPECTIVE, pick: (root) => root.hero },
        nextHero: { name: 'Next card', perspective: CARD_PERSPECTIVE, pick: (root) => root.nextHero },
        newBadge: { name: 'New badge', pick: (root) => root.newBadge },
        title: { name: 'Title', pick: (root) => root.titleText },
        counter: { name: 'Counter', pick: (root) => root.counterText },
        hint: { name: 'Hint', pick: (root) => root.hintText },
        skipButton: { name: 'Skip', pick: (root) => root.skipButton },
        collectButton: { name: 'Collect', pick: (root) => root.collectButton },
    },
    clips: [
        stubClip('start', () => import('../clips/packOpen/start.json')),
        stubClip('pack-idle', () => import('../clips/packOpen/pack-idle.json')),
        stubClip('open-pack', () => import('../clips/packOpen/open-pack.json'), () => {
            const preview = PackOpenAnimatorContainer.createPreview([
                previewCard('preview-hero'),
                previewCard('preview-next'),
            ]);
            preview.pack.y = 550;
            return preview;
        }),
        stubClip('flourish', () => import('../clips/packOpen/flourish.json')),
        stubClip('next-card', () => import('../clips/packOpen/next-card.json')),
        stubClip('swipe-card-left', () => import('../clips/packOpen/swipe-card-left.json')),
        stubClip('swipe-card-right', () => import('../clips/packOpen/swipe-card-right.json')),
        stubClip('show-summary', () => import('../clips/packOpen/show-summary.json')),
    ],
});
